const Update = require('./Update');
const StrokeUpdates = require('./StrokeUpdates');

module.exports = Base => class extends StrokeUpdates(Update(Base)) {};
